import { useState, React, useEffect } from "react";
import Modal from "../../../components/modal/Modal";
import { useForm } from "react-hook-form";
import { useAppContext } from "../../../context/AppContext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { getViewInstallments } from "../../../services/Financial/viewShipping/getViewInstallments";
import { useQuery } from "react-query";
import { Skeleton } from "primereact/skeleton";
import { formatDate } from "../../../utils/formatDate";
import { banks } from "../../../utils/banks";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { toast } from "react-toastify";
import { postReversalShipping } from "../../../services/Financial/postReversalShipping";
import { generateShipping } from "../../../services/Parcel/generateShipping";

const ModalViewInstallments = ({ visible, setVisible, viewInstallments }) => {
    const form = useForm();
    const errors = form.formState.errors;
    const [loading, setLoading] = useState(true);
    const [dataTable, setDataTable] = useState([]);
    const [itemsSelected, setItemsSelected] = useState([]);
    const [selectAll, setSelectAll] = useState(false);
    const shippingCode = viewInstallments?.shipping_code;

    const getBankLabel = (bankCode) => {
        const bank = banks.find(b => b.value === bankCode);
        return bank ? bank.label : 'Banco não encontrado';
    };
    const renderStatus = (status) => {
        /*
            *shipping
                #0 Não solicitou remessa
                #1 Remessa solicitada
                #2 Remessa em progessamento
                #3 Remessa gerada
                #4 Remessa com erro
                #5 Estorno remessa solicitada
                #6 Estorno remessa  em progessamento
                #7 Estorno remessa com erro
        */
        switch (status) {
            case 0:
                return "Não";
            case 1:
                return "Em Preparação";
            case 3:
                return "Gerada";
            case 4:
                return "Erro";
            case 5:
                return "Estorno solicitado";
            case 6:
                return "Estorno em processo";
            case 7:
                return "Erro ao estornar";
            default:
                return "";
        }
    };
    const handleSelectAll = () => {
        const newSelectAll = !selectAll;
        setSelectAll(newSelectAll);

        const updatedRows = filteredRows.map((row) => {
            if (row.check_id) {
                return { ...row, selected: newSelectAll };
            } else {
                return row;
            }
        });
        if (newSelectAll) {
            setItemsSelected(updatedRows);
        } else {
            setItemsSelected([]);
        }
    };
    const handleRowSelect = (rowData) => {
        const isSelected = itemsSelected.some((row) => row.id === rowData.id);
        let updatedSelectedRows = [...itemsSelected];
        if (isSelected) {
            updatedSelectedRows = updatedSelectedRows.filter(
                (row) => row.id !== rowData.id
            );
        } else {
            updatedSelectedRows.push(rowData);
        }

        if (updatedSelectedRows.length === filteredRows.length) {
            handleSelectAll();
        } else {
            setSelectAll(false);
        }
        setItemsSelected(updatedSelectedRows);
    };

    const acceptInstallments = async () => {
        if (itemsSelected.length === 0) {
            return toast.warning("Seleciona ao menos uma parcela.")
        }
        const notification = toast.loading(
            "Por favor aguarde, reenviado remessa..."
        );
        const data = {};
        data.installments_id = [];
        // data.enterprise_id = enterpriseId;
        itemsSelected.forEach((p) => data.installments_id.push(p.id));

        // console.log(itemsSelected)


        try {
            await postReversalShipping(data);

            await generateShipping(data);
            refetch();
            setItemsSelected([]);
            toast.update(notification, {
                render: "Ação efetuada com sucesso!",
                autoClose: 2000,
                theme: "colored",
                type: "success",
                isLoading: false,
            });
        } catch (error) {
            console.log(error)
            // Caso um erro seja capturado, mostra o toast de erro
            const errorMessage =
                error.message || "Ocorreu um erro inesperado.";

            toast.update(notification, {
                render: errorMessage,
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                type: "error",
                isLoading: false,
            });

            await refetch(); // Refaz o refetch mesmo em caso de erro
        }
    };

    const { nomenclatures } = useAppContext();
    const nomenclature = JSON.parse(nomenclatures);

    const { data, refetch } = useQuery({
        queryKey: [`viewInstallments_${shippingCode}`],
        queryFn: () => getViewInstallments(shippingCode),
        enabled: !!shippingCode,
        onSuccess: (data) => {
            setDataTable(data);
            setLoading(false);
        },
        onError: () => {
            setLoading(false);
        },
        onSettled: () => {
            setLoading(false);
        },
    });


    useEffect(() => {
        if (visible) {
            setLoading(true);
            if (shippingCode) {
                refetch();
            }
        }
    }, [visible, shippingCode, refetch]);

    const columns = [
        { field: "sale_id", header: "Cod. Venda" },
        { field: "id", header: "ID Parcela" },
        {
            field: "block", header: `${nomenclature[0].value} / ${nomenclature[1].value} `,
            body: (rowData) => rowData.block + " / " + rowData.land
        },
        { field: "client", header: "Cliente" },
        {
            field: "due_date", header: "Data de Vencimento",
            body: (rowData) => formatDate(rowData.due_date)
        },
        {
            field: "account_id", header: "Conta Corrente",
            body: (rowData) => {
                const accountData = rowData.currentAccount;
                const bankLabel = getBankLabel(accountData.bank);
                return `${bankLabel} | Agência: ${accountData.agency} - ${accountData.agency_digit} | Conta: ${accountData.account_number} - ${accountData.account_digit}`;
            }
        },
        {
            field: "shipping",
            header: "Status",
            body: (rowData) => {
                return renderStatus(rowData.shipping);
            },
        },
        { field: "shipping_message_error", header: "Motivo Erro" },
    ];

    const filteredRows = [];

    return (
        <Modal
            visible={visible}
            dynamicTitle={"Parcelas"}
            onHide={() => setVisible(false)}
            closable={true}
            dynamicWidth={"85vw"}
        >
            <div className="row px-3">
                {loading && <Skeleton width="100%" height="400px" />}
                {!loading && <DataTable
                    rows={15}
                    paginator
                    stripedRows
                    showGridlines
                    sortMode="multiple"
                    selectionMode="single"
                    rowsPerPageOptions={[15, 50, 100]}
                    value={dataTable}
                    emptyMessage="Nenhuma Informação foi encontrada."
                    tableStyle={{ minWidth: "0.8rem", fontSize: "0.7rem" }}
                >
                    <Column
                        field="check_id"
                        header={
                            <Checkbox
                                onChange={handleSelectAll} checked={selectAll}
                            />
                        }
                        body={(rowData) => {
                            const isShippingOne = rowData.shipping === 4;

                            const isStatusParcel = rowData.status === 0;

                            // Lógica para renderizar checkboxes
                            if (

                                (isShippingOne && isStatusParcel)
                            ) {
                                const index = filteredRows.findIndex(
                                    (row) => row.id === rowData.id
                                );
                                if (index === -1) {
                                    filteredRows.push(rowData);
                                }
                                return (
                                    <Checkbox
                                        checked={itemsSelected.some(
                                            (row) => row.id === rowData.id
                                        )}
                                        onChange={() => handleRowSelect(rowData)}
                                    />
                                )
                            } else {
                                return null;
                            }
                        }}
                    />
                    {columns.map((col, i) => (
                        <Column
                            sortable
                            body={col.body}
                            key={i}
                            field={col.field}
                            header={col.header}
                        />
                    ))}
                </DataTable>}
                  {/* <div className="text-center mt-3"> 
                <Button */}
                        {/* // onClick={() => { acceptInstallments() }}
                        // rounded
                        // icon="fa fa-undo"
                        // severity="success"
                        // disabled={itemsSelected.length === 0}
                        // label="Reenviar Remessa" */}
                {/* // className="p-inputtext-sm sme-2 m-auto" */}
                {/*  />
                </div> */}
            </div>
        </Modal >
    );
};

export default ModalViewInstallments;
